import React, { useState, useEffect, useContext } from "react"
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  TextField,
  Typography
} from '@material-ui/core';

import LanguageContext from "../contexts/LanguageContext"


import { setUser } from "../utils/auth"
import APIS from "../utils/APIS"

const ForgotPassword = () => {
  const navigate = useNavigate();

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [step, setStep] = useState(0)

  return (
    <>
      <Helmet>
        <title>{languageValues?.forgotPasswordPage?.title[actLanguage] || ''} | TheLab</title>
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              email: '',
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string().email(`${languageValues?.requiredField[actLanguage]}`).max(255).required(`${languageValues?.requiredField[actLanguage]}`),
            })}
            onSubmit={(values, { setSubmitting }) => {
              APIS.askForNewPasswordEmail({ email : values?.email?.trim()?.toLowerCase() }).then(result => {
                setStep(1)
                setSubmitting(false)
              })
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box sx={{ mb: 2, textAlign:"center" }}>
                  <Typography
                    color="text.blackTitle"
                    variant="h2"
                  >
                    {languageValues?.forgotPasswordPage?.title[actLanguage]}
                  </Typography>
                </Box>

                {step === 1 &&
                  <>
                    <Box sx={{
                      marginTop:"30px",
                      marginBottom:"15px",
                      fontSize:"20px",
                      textAlign:"center",
                      color : "text.blackTitle",
                    }}>
                      {languageValues?.forgotPasswordPage?.afterText[actLanguage]}
                    </Box>
                    <Box sx={{ py: 2 }}>
                      <RouterLink to="/login">
                        <Button
                          color="primary"
                          fullWidth
                          size="large"
                          variant="contained"
                        >
                          {languageValues?.loginPage?.button[actLanguage]}
                        </Button>
                      </RouterLink>
                    </Box>
                  </>
                }

                {step === 0 &&
                  <>
                    <Box sx={{textTransform:"uppercase", fontSize:["12px", "15px"]}}>
                      {languageValues?.loginPage?.emailField[actLanguage]}
                    </Box>
                    <TextField
                      error={Boolean(touched.email && errors.email)}
                      fullWidth
                      helperText={touched.email && errors.email}
                      margin="normal"
                      name="email"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="email"
                      value={values.email}
                      variant="outlined"
                      placeholder="ex. paul.durand@email.com"
                    />
                    <Box sx={{ py: 2 }}>
                      <Button
                        color="primary"
                        disabled={isSubmitting}
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                      >
                        {languageValues?.forgotPasswordPage?.button[actLanguage]}
                      </Button>
                    </Box>
                    <Box sx={{
                      marginTop:"15px",
                      marginBottom:"15px",
                      fontSize:"16px",
                      textAlign:"center",
                      color : "text.primary",
                    }}>
                      {languageValues?.loginPage?.alreadyAccount[actLanguage]}
                      <Link component={RouterLink} to="/login" sx={{marginLeft:"3px"}}>
                        {languageValues?.mainLayout?.itsHere[actLanguage]}
                      </Link>
                    </Box>
                  </>
                }
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </>
  );
};

export default ForgotPassword;
